"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOCUMENT_UPLOAD = exports.DOCUMENT_UPLOAD_DATA_FRAGMENT = exports.ALL_ATTACHED_GARAGE_CRAWLSPACE_INFO = void 0;
const client_1 = require("@apollo/client");
exports.ALL_ATTACHED_GARAGE_CRAWLSPACE_INFO = (0, client_1.gql) `
  fragment AllAttachedGarageCrawlspaceInfo on AttachedGarageCrawlspaceInfo {
    sqft
    netAreaOfFloodOpenings
    numFloodOpenings
    engineeredFloodOpenings
    oneFloodOpeningTwoSides
    numNonEngineeredOpenings
    numEngineeredOpenings
    netAreaNonEngineeredOpenings
    ratedAreaOfEngineeredOpenings
  }
`;
exports.DOCUMENT_UPLOAD_DATA_FRAGMENT = (0, client_1.gql) `
  fragment DocumentUploadDataFragment on DocumentUpload {
    id
    originalFilename
    name
    formData
    formStructure @skip(if: $isPublic)
    createdAt
    isDeletable @skip(if: $isPublic)
    hasAssociatedAIActionRun

    accountDocumentType {
      id
      name
      color
      allowedMimeTypes
      attachments {
        type
        customMapIds
      }
      order
      isSensitive
      documentType {
        id
        name
      }
    }
    issuedAt
    hiddenFromPublic
    mimeType

    submission @skip(if: $isPublic) {
      id
      formData
      tags {
        text
        display: tagDisplay
        uiSchemaPath
      }
      submissionTypeVersion {
        id
        submissionType {
          id
          name
          description
        }
      }
    }
  }
`;
exports.DOCUMENT_UPLOAD = (0, client_1.gql) `
  query getDocumentUpload($id: ID!, $isPublic: Boolean!) {
    documentUpload(id: $id) {
      ...DocumentUploadDataFragment

      objectType
      objectId
      property {
        id
        fullAddress
        latitude
        longitude
        hiddenFromPublic
      }

      customMapGeometry {
        id
        customMapId
      }

      elevationCertificate {
        id
        buildingOwnerName
        errorDetectionEligibility {
          status
          heading
          note
        }
        type
        propertyDescription
        buildingUse
        latitude
        longitude
        horizontalDatum
        buildingDiagramNumber
        firmIndexDate
        firmPanelEffectiveDate
        floodZone
        baseFloodElevation
        baseFloodElevationDatum
        baseFloodElevationDatumOther
        baseFloodElevationSource
        fiveHundredYearFloodElevation {
          value
          units
        }
        isBuildingLocatedInCbrsOrOpa
        buildingLocatedInCbrsOrOpaDesignationDate
        buildingLocatedInCbrsOrOpa
        buildingLocatedSeawardOfLimwa
        benchmarkUtilized
        elevationDatum
        elevationDatumOther
        verticalDatum
        elevationDatumComments
        buildingElevationSource
        buildingElevationInfo {
          topOfBottomFloor {
            value
            units
          }
          topOfNextHigherFloor {
            value
            units
          }
          bottomOfLowestHorizontalStructuralMember {
            value
            units
          }
          attachedGarage {
            value
            units
          }
          lowestElevationOfMachineryOrEquipment {
            value
            units
          }
          lowestAdjacentGrade {
            value
            units
            type
          }
          highestAdjacentGrade {
            value
            units
            type
          }
          lowestAdjacentGradeAtLowestElevationOfDeckOrStairs {
            value
            units
          }
        }
        issuedAt
        comments
        coordinatesProvidedBySurveyor
        conversionFactorUsed
        streetAddress
        nfipCommunityName
        nfipCommunityNumber
        nfipCountyName
        nfipState
        state
        city
        zipcode
        certifierName
        certifierLicenseNumber
        certifierInfo {
          name
          licenseNumber
          email
          telephone
          sealPresent
          signaturePresent
        }
        propertyOwnerInfo {
          name
          signaturePresent
          date
        }
        firmMapNumber
        firmSuffix
        extractedData
        finishedConstruction
        formYear
        attachedGarageInfo {
          ...AllAttachedGarageCrawlspaceInfo
        }
        crawlspaceInfo {
          ...AllAttachedGarageCrawlspaceInfo
        }
        buildingMeasurementInfo {
          measurementsBasedOn
          topOfBottomFloorElevatedPerOrdinance
          offsets {
            topOfBottomFloorAboveOrBelowHag {
              value
              units
              aboveOrBelow
            }
            topOfBottomFloorAboveOrBelowLag {
              value
              units
              aboveOrBelow
            }
            nextHigherFloorAboveOrBelowHag {
              value
              units
              aboveOrBelow
            }
            attachedGarageTopOfSlabAboveOrBelowHag {
              value
              units
              aboveOrBelow
            }
            topOfMachineryPlatformAboveOrBelowHag {
              value
              units
              aboveOrBelow
            }
          }
        }
        communityInfo {
          sectionCTakenFromOtherAuthorizedSource
          sectionECompletedByLocalOfficial
          sectionHCompletedByLocalOfficial
          sectionGCommentsProvidedByLocalOfficial
          communityInfoProvidedForFloodplainManagementPurposes
          permitNumber
          permitDateIssued
          certificateOfComplianceOrOccupancyDateIssued
          permitIssuedForNewConstructionOrSI
          elevations {
            asBuiltLowestFloor {
              value
              units
              datum
            }
            bottomOfAsBuiltLowestHorizontalStructuralMember {
              value
              units
              datum
            }
            bfeOrDepthOfFloodingAtBuildingSite {
              value
              units
              datum
            }
            communityMinimumRequirementOfLowestFloorOrLowestHorizontalStructuralMember {
              value
              units
              datum
            }
          }
          varianceIssued
          localOfficialInfo {
            name
            telephone
            email
            dateSigned
            comments
          }
        }
        everyPageHasHeaderAddress
        pageHeaderAddressesAreConsistent
        numberOfPhotosProvided
        everyPhotoIsInColor
        permit @skip(if: $isPublic) {
          id
          permitNumber
          permitDate
          type
          final
          floodProofingCertificateRequired
          vZoneDesignCertificateRequired
          comments
        }
        validationErrors {
          data {
            errorCode
            id
            issue
            type
            value
            valueAttr
            field
            note
            ignored
            ignoredReason @skip(if: $isPublic)
          }
          count
        }
        firms {
          id
          name
          floodway
          jurisdictions
          useForRegulation
          datum
          stringStaticBFE
          stringDepth
          isApproximateBfe
          mscLink
          coastalA
          panels {
            panelNumber
          }
          zones {
            floodzone
            floodway
            coastalA
            stringStaticBFE
            stringDepth
            datum
          }
        }
      }

      certificateUpload {
        id
        cancelationReason @skip(if: $isPublic)
        status
        lowConfidence @skip(if: $isPublic)
      }
    }
  }

  ${exports.DOCUMENT_UPLOAD_DATA_FRAGMENT}
  ${exports.ALL_ATTACHED_GARAGE_CRAWLSPACE_INFO}
`;
(0, client_1.gql) `
  mutation UploadDocuments($data: CreateDocumentUploadsInput!) {
    createDocumentUploads(data: $data)
  }
`;
//# sourceMappingURL=data:application/json;base64,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